import cx from 'classnames'

import { zIndexStyles } from '../../libs/zIndexStyles'
import { CircularSpinner } from '../circularSpinner/CircularSpinner'

type Props = {
  position?: 'absolute' | 'relative'
}

export const FullscreenSpinner = ({ position = 'absolute' }: Props) => (
  <div
    className={cx(
      'flex h-full w-full items-center justify-center',
      zIndexStyles('tips'),
      {
        absolute: 'absolute left-0 top-0',
        relative: 'grow',
      }[position],
    )}
  >
    <CircularSpinner className="size-20" spinnerDuration="1.0s" />
  </div>
)
